import { gql } from '@apollo/client';

// ===================================================================
// Group 1: Trial & Plan Management
// ===================================================================

export const START_TRIAL_ADDON = gql`
  mutation StartTrialAddOn($addOn: AddOnInput!, $subAccountId: String) {
    startTrialAddOn(addOn: $addOn, subAccountId: $subAccountId) {
      status
      message
      code
    }
  }
`;

export const CANCEL_TRIAL_ADDON = gql`
  mutation CancelTrialAddOn($addOn: AddOnInput!, $subAccountId: String) {
    cancelTrialAddOn(addOn: $addOn, subAccountId: $subAccountId) {
      status
      message
      code
    }
  }
`;

export const CHANGE_PLAN_TRIAL = gql`
  mutation ChangePlanTrial($planFeatureId: String!, $currency: String, $subAccountId: String) {
    changePlanTrial(
      planFeatureId: $planFeatureId
      currency: $currency
      subAccountId: $subAccountId
    ) {
      status
      message
      code
    }
  }
`;

// ===================================================================
// Group 2: Subscription Charging
// ===================================================================

export const CHARGE_SUBSCRIPTION_USER = gql`
  mutation ChargeSubscriptionUser($params: ChargeSubscriptionInput!) {
    chargeSubscriptionUser(params: $params) {
      status
      message
      code
      coupon
      couponNumber
    }
  }
`;

export const CHARGE_SUBSCRIPTION_SPECIAL = gql`
  mutation ChargeSubscriptionSpecial($data: ChargeSubscriptionSpecialInput!) {
    chargeSubscriptionSpecial(data: $data) {
      status
      message
      code
    }
  }
`;

export const PAYMENT_INVOICES_UNPAID = gql`
  mutation PaymentInvoicesUnpaid($subAccountId: String, $teamId: String) {
    paymentInvoicesUnpaid(subAccountId: $subAccountId, teamId: $teamId) {
      status
      message
      code
    }
  }
`;

// ===================================================================
// Group 3: Subscription Info & Preview
// ===================================================================

export const GET_UPCOMING_SUBSCRIPTION_REVIEW = gql`
  query GetUpcomingSubscriptionReview($params: UpcomingSubscriptionReviewInput!) {
    getUpcomingSubscriptionReview(params: $params)
  }
`;

export const GET_UPCOMING_SUBSCRIPTION = gql`
  query GetUpcomingSubscription(
    $isTrial: Boolean
    $stripe_plan_id: String
    $subAccountId: String
    $teamId: String
  ) {
    getUpcomingSubscription(
      isTrial: $isTrial
      stripe_plan_id: $stripe_plan_id
      subAccountId: $subAccountId
      teamId: $teamId
    )
  }
`;

export const GET_DEVICE_FREES = gql`
  query GetDeviceFrees($subAccountId: String, $teamId: String) {
    getDeviceFrees(subAccountId: $subAccountId, teamId: $teamId)
  }
`;

export const GET_UPCOMING_AND_UNPAID_SUBSCRIPTION = gql`
  query GetUpcomingAndUnpaidSubscription($subAccountId: String, $teamId: String) {
    getUpcomingAndUnpaidSubscription(subAccountId: $subAccountId, teamId: $teamId) {
      status
      message
      code
    }
  }
`;

export const GET_COUPON_STRIPE = gql`
  query GetCouponStripe {
    getCouponStripe
  }
`;

export const GET_SUBSCRIPTION_INFO_STRIPE = gql`
  query GetSubscriptionInfoStripe($subAccountId: String, $teamId: String) {
    getSubscriptionInfoStripe(subAccountId: $subAccountId, teamId: $teamId)
  }
`;

// ===================================================================
// Group 4: Add-on Management
// ===================================================================

export const UPDATE_SUBSCRIPTION_ADDON = gql`
  mutation UpdateSubscriptionAddOn(
    $addOn: UpdateSubscriptionAddOnInput!
    $subAccountId: String
    $teamId: String
  ) {
    updateSubscriptionAddOn(addOn: $addOn, subAccountId: $subAccountId, teamId: $teamId) {
      status
      message
      code
      isFinishAction
      invoiceNumber
      invoicePdf
    }
  }
`;

export const EDIT_SUBSCRIPTION_ADDON = gql`
  mutation EditSubscriptionAddOn($addOn: AddOnInput!) {
    editSubscriptionAddOn(addOn: $addOn) {
      status
      message
      code
    }
  }
`;

// ===================================================================
// Group 5: Promo & Billing Info
// ===================================================================

export const UPDATE_PROMO_CODE_SUBSCRIPTION = gql`
  mutation UpdatePromoCodeSubscription(
    $promoCode: String!
    $subAccountId: String
    $teamId: String
  ) {
    updatePromoCodeSubscription(promoCode: $promoCode, subAccountId: $subAccountId, teamId: $teamId)
  }
`;

export const UPDATE_STRIPE_EMAIL = gql`
  mutation UpdateStripeEmail($email: String!, $subAccountId: String, $teamId: String) {
    updateStripeEmail(email: $email, subAccountId: $subAccountId, teamId: $teamId) {
      status
      message
      code
    }
  }
`;

export const UPDATE_STRIPE_BILLING_INFO = gql`
  mutation UpdateStripeBillingInfo(
    $data: StripeBillingInfoInput!
    $subAccountId: String
    $teamId: String
  ) {
    updateStripeBillingInfo(data: $data, subAccountId: $subAccountId, teamId: $teamId) {
      status
      message
      code
    }
  }
`;

export const STRIPE_BUILD_ELEMENT = gql`
  query StripeBuildElement(
    $form: SetupIntentForm!
    $currency: String
    $isAttachCustomer: Boolean
    $subAccountId: String
    $teamId: String
  ) {
    stripeBuildElement(
      form: $form
      currency: $currency
      isAttachCustomer: $isAttachCustomer
      subAccountId: $subAccountId
      teamId: $teamId
    )
  }
`;

// ===================================================================
// Group 6: Tax Management
// ===================================================================

export const GET_STRIPE_CUSTOMER_TAXABLE = gql`
  query GetStripeCustomerTaxable($subAccountId: String, $teamId: String) {
    getStripeCustomerTaxable(subAccountId: $subAccountId, teamId: $teamId)
  }
`;

export const UPDATE_STRIPE_TAX = gql`
  mutation UpdateStripeTax($tax: StripeTaxInput!, $subAccountId: String, $teamId: String) {
    updateStripeTax(tax: $tax, subAccountId: $subAccountId, teamId: $teamId)
  }
`;

export const DELETE_STRIPE_TAX = gql`
  mutation DeleteStripeTax($taxId: String!, $subAccountId: String, $teamId: String) {
    deleteStripeTax(taxId: $taxId, subAccountId: $subAccountId, teamId: $teamId) {
      status
      message
      code
    }
  }
`;

// ===================================================================
// Group 7: Plan Downgrade & Resume
// ===================================================================

export const DOWNGRADE_TRIAL_TO_FREE = gql`
  mutation DowngradeTrialToFreePlan($subAccountId: String, $currency: String) {
    downgradeTrialToFreePlan(subAccountId: $subAccountId, currency: $currency) {
      status
      message
      code
    }
  }
`;

export const DOWNGRADE_PAID_TO_FREE = gql`
  mutation DowngradePaidToFreePlan($subAccountId: String) {
    downgradePaidToFreePlan(subAccountId: $subAccountId) {
      status
      message
      code
    }
  }
`;

/**
 * Schedule subscription cancellation at end of billing period (#1113).
 * Backend: open-api `payment.resolver.ts:cancelSubscription` — sets
 * `payment.scheduleCancel` so the Subscription page enters the canceled
 * state ("scheduled to end on …" + Resume Subscription button).
 *
 * `survey` is required by the backend's ValidationPipe even when the
 * actual answers are captured server-side via TypeForm's webhook — we
 * pass a populated stub with empty `questions` to satisfy validation.
 */
export const CANCEL_SUBSCRIPTION = gql`
  mutation CancelSubscription($subAccountId: String, $survey: SubmitUserSurveyInput!) {
    cancelSubscription(subAccountId: $subAccountId, survey: $survey) {
      status
      message
      code
    }
  }
`;

export const RESUME_SUBSCRIPTION = gql`
  mutation ResumeSubscription($subAccountId: String) {
    resumeSubscription(subAccountId: $subAccountId) {
      status
      message
      code
    }
  }
`;

export const CHANGE_PLAN_TEAM_BILLING = gql`
  mutation ChangePlanTeamBilling($subAccountId: String) {
    changePlanTeamBilling(subAccountId: $subAccountId) {
      status
      message
      code
    }
  }
`;

// ===================================================================
// Group 8: Currency
// ===================================================================

export const GET_PRICE_AUTO_CONVERT_CURRENCY = gql`
  query GetPriceAutoConvertCurrency($priceId: String!) {
    getPriceAutoConvertCurrency(priceId: $priceId)
  }
`;

export const GET_PRICE_AUTO_CONVERT_CURRENCIES = gql`
  query GetPriceAutoConvertCurrencies {
    getPriceAutoConvertCurrencies
  }
`;

// ===================================================================
// Group 9: Coupons
// ===================================================================

export const GET_COUPONS = gql`
  query GetCoupons($first: Int, $after: String) {
    getCoupons(first: $first, after: $after) {
      page {
        edges {
          node {
            _id
            coupon
            couponNumber
            couponUsed
            price
            createdAt
            expiredAt
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

/**
 * Coupon node as returned by the `getCoupons` query.
 *
 * scio1 parity: `couponUsed` is a Number (count of screens redeemed). Open-api
 * coupon.model.ts declares it as Number to match scio1's SimpleSchema
 * (`scio/imports/api/deviceCoupons/collection.js:20`).
 */
export interface CouponNode {
  _id: string;
  coupon: string;
  couponNumber: number;
  couponUsed: number;
  price: number | null;
  createdAt: string;
  expiredAt: string;
}

export interface GetCouponsResult {
  getCoupons: Array<{
    page: {
      edges: Array<{ node: CouponNode }>;
      pageInfo: {
        hasNextPage: boolean;
        endCursor: string | null;
      };
    };
  }>;
}

export interface GetCouponsVariables {
  first?: number;
  after?: string;
}

// ===================================================================
// Group 10: Plan Change Validation
// ===================================================================

export const VALIDATE_CHANGE_PLAN = gql`
  query ValidateChangePlan($planAlias: String!, $subAccountId: String, $isPassTrial: Boolean) {
    validateChangePlan(
      planAlias: $planAlias
      subAccountId: $subAccountId
      isPassTrial: $isPassTrial
    )
  }
`;

// ===================================================================
// Group 11: Add-on Device Management
// ===================================================================

export const GET_DEVICES_ADDON = gql`
  query GetDevicesAddOn(
    $key: String!
    $search: String
    $offset: Int
    $limit: Int
    $sortBy: String
    $sortType: Int
    $subAccountId: String
  ) {
    getDevicesAddOn(
      key: $key
      search: $search
      offset: $offset
      limit: $limit
      sortBy: $sortBy
      sortType: $sortType
      subAccountId: $subAccountId
    )
  }
`;

export const REMOVE_ADDON_DEVICES = gql`
  mutation RemoveAddonDevices(
    $deviceIds: [String!]!
    $key: String!
    $subAccountId: String
    $force: Boolean
  ) {
    removeAddonDevices(deviceIds: $deviceIds, key: $key, subAccountId: $subAccountId, force: $force)
  }
`;

/**
 * #1181 — Pre-check for the addon-deactivate flow. Returns the list of devices
 * currently playing AeriCast/VideoWall/OptiDev content that would be orphaned
 * by removeAddonDevices. FE uses this for optimistic UX (show "Stop Playing &
 * Deactivate" warning before submitting); backend re-validates internally.
 */
export const VALIDATE_DELETE_DEVICE_ASSIGN_ADDON = gql`
  query ValidateDeleteDeviceAssignAddon(
    $deviceIds: [String!]!
    $key: String!
    $subAccountId: String
  ) {
    validateDeleteDeviceAssignAddon(deviceIds: $deviceIds, key: $key, subAccountId: $subAccountId)
  }
`;

export const UPDATE_ADDON_DEVICES = gql`
  mutation UpdateAddonDevices(
    $deviceIds: [String!]
    $key: String!
    $subAccountId: String
    $tags: [String!]
    $tagRuleId: String
  ) {
    updateAddonDevices(
      deviceIds: $deviceIds
      key: $key
      subAccountId: $subAccountId
      tags: $tags
      tagRuleId: $tagRuleId
    )
  }
`;

// ===================================================================
// Group 12: Payment History
// ===================================================================

export const GET_PAYMENT_HISTORY = gql`
  query GetPaymentHistory(
    $limit: Float
    $starting_after: String
    $ending_before: String
    $subAccountId: String
    $teamId: String
  ) {
    getPaymentHistory(
      limit: $limit
      starting_after: $starting_after
      ending_before: $ending_before
      subAccountId: $subAccountId
      teamId: $teamId
    )
  }
`;

export const GET_STRIPE_CUSTOMER_INFO = gql`
  query GetStripeCustomerInfo($subAccountId: String, $teamId: String) {
    getStripeCustomerInfo(subAccountId: $subAccountId, teamId: $teamId)
  }
`;

export const REGISTER_PAYMENT_METHOD = gql`
  mutation RegisterPaymentMethod(
    $paymentMethodId: String!
    $chargeNow: Boolean
    $subAccountId: String
    $teamId: String
  ) {
    registerPaymentMethod(
      paymentMethodId: $paymentMethodId
      chargeNow: $chargeNow
      subAccountId: $subAccountId
      teamId: $teamId
    ) {
      status
      message
      code
    }
  }
`;

export const SEND_INVOICE_EMAIL = gql`
  mutation SendInvoiceEmail($recipientEmail: String!, $subject: String!, $invoiceUrl: String!) {
    sendInvoiceEmail(recipientEmail: $recipientEmail, subject: $subject, invoiceUrl: $invoiceUrl) {
      status
      message
      code
    }
  }
`;

// ===================================================================
// Group 13: Sub-Account Management
// ===================================================================

export const GET_SUB_ACCOUNT_LIST = gql`
  query GetSubAccountList($offset: Float, $limit: Float) {
    getSubAccountList(offset: $offset, limit: $limit)
  }
`;

export const GET_SUB_ACCOUNT_INFO = gql`
  query GetSubAccountInfo($subAccountId: String!) {
    getSubAccountInfo(subAccountId: $subAccountId)
  }
`;

export const REMOVE_SUB_ACCOUNT = gql`
  mutation RemoveSubAccount($subAccountId: String!) {
    removeSubAccount(subAccountId: $subAccountId) {
      status
      message
      code
    }
  }
`;

export const REMOVE_INVITE_SUB_ACCOUNT = gql`
  mutation RemoveInviteSubAccount($subAccountId: String!) {
    removeInviteSubAccount(subAccountId: $subAccountId) {
      status
      message
      code
    }
  }
`;

export const ACTIVE_SUB_ACCOUNT = gql`
  mutation ActiveSubAccount {
    activeSubAccount {
      status
      message
      code
    }
  }
`;

export const LINK_SUB_ACCOUNT = gql`
  mutation LinkSubAccount($email: String!, $token: String) {
    linkSubAccount(email: $email, token: $token)
  }
`;

export const ADD_NEW_SUB_ACCOUNT = gql`
  mutation AddNewSubAccount($input: JSONObject!) {
    addNewSubAccount(input: $input)
  }
`;

export const ADD_NEW_USER_TEAM_BILLING = gql`
  mutation AddNewUserTeamBilling($input: JSONObject!) {
    addNewUserTeamBilling(input: $input)
  }
`;

export const UPDATE_SUB_ACCOUNT_NAME = gql`
  mutation UpdateSubAccountName($subAccountId: String!, $name: String!) {
    updateSubAccountName(subAccountId: $subAccountId, name: $name)
  }
`;

export const GET_TEAM_BILLING_INFO = gql`
  query GetTeamBillingInfo($teamId: String!) {
    getTeamBillingInfo(teamId: $teamId)
  }
`;

export const GET_PARENT_INVITE_SUBACCOUNT = gql`
  query GetParentInviteSubaccount {
    getParentInviteSubaccount
  }
`;

export const CONFIRM_LINK_SUB_ACCOUNT = gql`
  mutation ConfirmLinkSubAccount($action: String!) {
    confirmLinkSubAccount(action: $action)
  }
`;

export const GET_INVOICES_UNPAID = gql`
  query GetInvoicesUnpaid($subAccountId: String, $teamId: String) {
    getInvoicesUnpaid(subAccountId: $subAccountId, teamId: $teamId)
  }
`;

// ===================================================================
// Response Types
// ===================================================================

export interface PaymentStatusResponse {
  status: boolean;
  message?: string;
  code?: number;
}

export interface StripeBuildElementResponse {
  client_secret: string;
  paymentMethodOrder: string[];
}

export interface SubscriptionInfoResponse {
  plan?: Record<string, unknown>;
  quantity?: number;
  interval?: string;
}

/**
 * Upcoming subscription review data returned from getUpcomingSubscriptionReview.
 * Backend returns JSONObject — these are the known fields.
 */
export interface UpcomingSubscriptionReviewData {
  total?: number;
  credit?: number;
  subtotal?: number;
  isMonthlyCreditNext?: boolean;
  /** Total tax in dollars, parsed from Stripe invoice.total_tax_amounts (#1178). */
  tax?: number;
  /** Tax breakdown for display — name like "Sales tax - TX(8.25%)", `tax` in cents. */
  taxs?: Array<{ name: string; tax: number }>;
}

/**
 * Upcoming subscription data returned from getUpcomingSubscription.
 * Backend returns JSONObject — these are the known fields.
 */
export interface UpcomingSubscriptionData {
  total?: number;
  credit?: number;
  discount?: Record<string, unknown>;
  taxs?: Record<string, unknown>[];
  discountAmount?: number;
  upcoming?: Record<string, unknown>;
  stripePlanPrice?: number;
  stripeDiscount?: number;
  stripeDuration?: string;
  isShowDetailUpcoming?: boolean;
  email?: string;
}

// ===================================================================
// Variable Types (matching open-api input types)
// ===================================================================

export interface ChargeSubscriptionVariables {
  params: {
    planId: 'MONTHLY' | 'YEARLY' | 'YEARLY_FREEDEVICE';
    planFeatureId: string;
    maxQuantityNormal: number;
    promoCode?: string;
    subAccountId?: string;
    collection_method?: string;
    days_until_due?: number;
    type?: 'TEAM' | 'SUBACCOUNT' | 'FREE_PLAN';
    teamId?: string;
    deviceFrees?: { _id?: string; maxQuantity: number }[];
    deviceFreesOrigin?: { _id?: string; maxQuantity: number }[];
    subscription_cancel_at_period_end?: boolean;
    isMonthShowRefund?: boolean;
    currency?: string;
    isOrderFreeDevice?: boolean;
    invoicePendings?: {
      customer: string;
      amount: number;
      currency: string;
      description?: string;
      subscription?: string;
      discountable?: boolean;
    }[];
    isDisableCreateCouponFreeDevice?: boolean;
    paymentMethod?: {
      paymentMethodId?: string;
      brand?: string;
      last4?: string;
      exp_month?: number;
      exp_year?: number;
      funding?: string;
      type?: string;
    };
    email?: string;
    teamName?: string;
    teamDescription?: string;
  };
}

export interface UpcomingSubscriptionReviewVariables {
  params: {
    planId: 'MONTHLY' | 'YEARLY' | 'YEARLY_FREEDEVICE';
    planFeatureId: string;
    maxQuantityNormal: number;
    deviceFrees?: {
      _id?: string;
      maxQuantity: number;
      expiredDate?: string;
      invoiceId?: string;
    }[];
    deviceFreesOrigin?: {
      _id?: string;
      maxQuantity: number;
      expiredDate?: string;
      invoiceId?: string;
    }[];
    subscription_cancel_at_period_end?: boolean;
    proration_date?: number;
    subTotal?: number;
    subAccountId?: string;
    teamId?: string;
  };
}

export interface UpdateSubscriptionAddOnVariables {
  addOn: {
    key: 'AERICAST' | 'VIDEOWALL' | 'BACKGROUNDMUSIC';
    maxQuantity: number;
    type?: string;
    selectedPlanTier?: string;
  };
  subAccountId?: string;
  teamId?: string;
}

export interface StripeBuildElementVariables {
  form:
    | 'ORDER_DEVICE'
    | 'ORDER_DEVICE_FREE_DEVICE'
    | 'ORDER_DEVICE_SHOP'
    | 'BILLING_PAGE'
    | 'SUBSCRIPTION'
    | 'SUBACCOUNT'
    | 'TEAM'
    | 'FREE_PLAN';
  currency?: string;
  isAttachCustomer?: boolean;
  subAccountId?: string;
  teamId?: string;
}

export interface StripeBillingInfoVariables {
  data: {
    city?: string;
    country?: string;
    line1?: string;
    line2?: string;
    postal_code?: string;
    state?: string;
    phone?: string;
  };
  subAccountId?: string;
  teamId?: string;
}

export interface StripeTaxVariables {
  tax: {
    code: string;
    value: string;
    type?: 'NEW' | 'EDIT';
    id?: string;
  };
  subAccountId?: string;
  teamId?: string;
}
